import "dayjs/locale/ru";

import { LoadingIndicator } from "@app/shared/ui/LoadingIndicator";
import { FxIdWebFeaturesProfileGetResponse } from "@fxid/openapi-client";
import { queries } from "@fxid/openapi-client";
import { Center, Grid, Paper, Stack, Title } from "@mantine/core";
import { GameSectionData } from "@pages/ProfilePage/game_section_data.ts";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { GameCard } from "./GameCard";
import classes from "./Profile.module.scss";

dayjs.extend(relativeTime);

export const ConnectedGamesSection = ({ profile }: { profile: FxIdWebFeaturesProfileGetResponse }) => {
	const { t, i18n } = useTranslation();

	useEffect(() => {
		dayjs.locale(i18n.language);
	}, [i18n.language]);

	const { data, isPending } = useQuery(queries.games.listWithConfigs);

	if (isPending) {
		return (
			<Paper withBorder radius="lg" className={classes.glassCard} p="xl">
				<Center>
					<LoadingIndicator />
				</Center>
			</Paper>
		);
	}

	if (!profile || !data) return null;

	const connectedGamesWithConfigs: GameSectionData[] = profile.ConnectedGames.map((g) => {
		const gameConfig = data.AvailableGames.find((el) => el.GameSystemName === g.Game);
		return gameConfig ? { profileGameData: g, gameConfig } : undefined;
	}).filter((g): g is GameSectionData => Boolean(g));

	return (
		<Stack>
			{connectedGamesWithConfigs.map((g) => (
				<GameCard gameData={g} />
			))}
		</Stack>
	);
};
